/**
 * Spanish Common Translations
 * 通用翻译模块 - 西班牙语
 * 
 * 包含导航栏 (nav) 和页脚 (footer) 的翻译
 */

import type { CommonTranslations } from '../../types';

export const esCommon: CommonTranslations = {
  nav: {
    home: 'Inicio',
    products: 'Productos',
    technology: 'Tecnología',
    about: 'Sobre Nosotros',
    contact: 'Contacto',
    faq: 'Preguntas Frecuentes',
  },
  footer: {
    contact: 'Contáctenos',
    phone: 'Teléfono',
    email: 'Correo Electrónico',
    address: 'Dirección',
    rights: 'Todos los derechos reservados.',
    brandDesc: 'Fabricante profesional de calentadores radiantes infrarrojos. Brindando calor, comodidad y eficiencia energética al mundo desde 2006.',
    products: 'Productos',
    support: 'Soporte',
    newsletter: 'Mantente Actualizado',
    newsletterDesc: 'Suscríbete para recibir las últimas actualizaciones de productos y noticias de la industria.',
    join: 'Únete',
    catalog: 'Descargar Catálogo',
    emailPlaceholder: 'Ingresa tu correo electrónico',
    product1: 'Calefactor de Infrarrojos',
    product2: 'Calefactor Portátil',
    product3: '',
    product4: '',
    privacy: 'Política de Privacidad',
    terms: 'Términos de Servicio',
    sitemap: 'Mapa del Sitio',
    installationGuide: 'Guía de Instalación',
    warrantyPolicy: 'Política de Garantía',
  },
};
